import API from "./apiconfig.js";
const Apibase = API.apiBase; //服务端API


const layui = window.layui;
const $ = window.$;

const Http = {
    ResStatus: {
        loginOut: ["400201", "400202", "400203", "400207"], //登录过期 未登录
        success: ["0", "success"], //成功
        outAcess: ["400206", "403"] //无权限
    },
    SuccessResult: function(res, callFunc) {
        var jsonObj = {};
        if (res != undefined && res != "undefined" && res != null) {
            if (typeof(res) == "string") {
                jsonObj = JSON.parse(res);
            } else {
                jsonObj = res;
            }
        }
        if (Http.ResStatus.loginOut.indexOf(jsonObj.code) >= 0) {
            //登录过期
            Http.CheckLogin();
            return;
        } else if (Http.ResStatus.outAcess.indexOf(jsonObj.code) >= 0) {


            //alert("没有权限！");




            top.location.href = "/html/msg/403.html?api=";

            return;

            // layui.use('layer', function() {
            //     var layer = layui.layer;
            //     let layerObj = {
            //         title: "提示",
            //         type: 2,
            //         maxmin: false,
            //         id: "403",
            //         area: ["100%", "100%"],
            //         content: "/static/html/msg/403.html?api=",
            //         cancel: function(index, layero) {
            //             layero;
            //             layer.close(index);
            //             // if (confirm('确定要关闭么'))
            //             // { //只有当点击confirm框的确定时，该层才会关闭
            //             //     layer.close(index)
            //             // }
            //             return false;
            //         },
            //         end: function() {
            //             //J.Alert("销毁了");

            //         }
            //     }
            //     setTimeout(() => {
            //         let ly = layer.open(layerObj);

            //         layer.full(ly);
            //     }, 2000);

            // });



        } else {
            let code = jsonObj.code;
            let data = jsonObj.data;


            let msg = jsonObj.message;
            // if (msg.toLowerCase().indexOf("connection") >= 0) {
            //     console.log(msg);
            //     msg = "网络请求出错";
            // }

            // if (msg.toLowerCase().indexOf("sql") >= 0) {
            //     console.log(msg);
            //     msg = "sql出错";
            // }
            // if (msg.toLowerCase().indexOf("java") >= 0) {
            //     console.log(msg);
            //     msg = "java出错";
            // }




            let returnObj = { "Code": code, "Data": data, "Msg": msg, "code": code, "data": data, "msg": msg, "message": msg, "Message": msg }
            callFunc(returnObj);
        }
    },
    Error: function(errorObj, failcb) {
        //alert("请求出错：" + errorThrown);
        /* eslint-disable*/
        let code = -3;
        let data = [];
        console.log(errorObj);
        //let msg = "请求出错：" + errorObj.XMLHttpRequest.status + "_" + "服务开小差，请稍后再试。"; //errorObj.XMLHttpRequest.responseText;
        let msg = "请稍后刷新重试";
        let returnObj = { "Code": code, "Data": data, "Msg": msg, "code": code, "data": data, "msg": msg, "message": msg, "Message": msg }
        failcb(returnObj);
    },
    GetToken: function(url) {

        var user = layui.data('ehr_pcUser');

        let token = user.Token;
        // var layUrl = layui.url(url);
        // if (!layUrl.search.token) {} else {
        //     token = layUrl.search.token;
        // }
        return token;
    },
    ApiUrl: function(api, def) {
        console.log(api)
        var apiBase = Http.backBaseApi(api);
        if (apiBase.lastIndexOf("/") == apiBase.length - 1) {
            apiBase = apiBase.substr(0, apiBase.length - 1);
        }
        if (api.indexOf("http") == 0 || api.indexOf("//") == 0 || api.indexOf("://") == 0) {
            apiBase = "";
        }
        //
        var newUrl = "";
        if (apiBase != "") {
            if (api.indexOf("/") == 0) {
                newUrl = apiBase + api;
            } else {
                newUrl = apiBase + "/" + api;
            }
        } else {
            newUrl = api;
        }
        //
        if (newUrl.indexOf("#") < 0) {
            newUrl += "#";
        }
        var hashStr = newUrl.split("#")[1];
        var ul = newUrl.split("#")[0];
        if (ul.indexOf("?") > 0) {
            ul += "&";
        } else {
            ul += "?";
        }
        //以下为追加默认参数
        ul += "app=ehr_pc";
        if (typeof def != 'undefined') {
            ul += "&" + def;
        }
        ul += "#" + hashStr;
        return ul;

    },



    ////--添、删、改 提交数据-- 
    Post: function(url, data, callFunc, failcb) {
        let token = this.GetToken(url);
        let serverApi = Http.ApiUrl(url);
        $.ajax({
            type: "post",
            async: false,
            url: serverApi,
            data: data,
            headers: {
                "token": token
            },
            contentType: 'application/json;charset=utf-8',
            timeout: 59000,
            dataType: 'json',
            success: function(res) {
                Http.SuccessResult(res, callFunc);
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                if (!failcb) {
                    failcb = callFunc;
                }
                Http.Error({ XMLHttpRequest, textStatus, errorThrown, data }, failcb)
            }
        });
    },



    ////--form表单提交数据-- 
    Post2: function(url, data, callFunc, failcb) {
        let token = this.GetToken(url);
        let serverApi = Http.ApiUrl(url);
        $.ajax({
            type: "post",
            async: false,
            url: serverApi,
            data: data,
            headers: {
                "token": token
            },
            contentType: 'application/x-www-form-urlencoded; charset=UTF-8',
            timeout: 59000,
            dataType: 'json',
            success: function(res) {
                Http.SuccessResult(res, callFunc);
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                if (!failcb) {
                    failcb = callFunc;
                }
                Http.Error({ XMLHttpRequest, textStatus, errorThrown, data }, failcb)
            }
        });
    },
    //GET通用顶级获取数据方法
    Get: function(url, data, callFunc, failcb) {
        let token = this.GetToken(url);
        let serverApi = Http.ApiUrl(url);
        $.ajax({
            type: "get",
            async: false,
            url: serverApi,
            data: data,
            headers: {
                "token": token
            },
            timeout: 59000,
            dataType: "json",
            //jsonp: "callback", //传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(一般默认为:callback)
            //jsonpCallback:"?",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名，也可以写"?"，jQuery会自动为你处理数据
            success: function(res) {

                Http.SuccessResult(res, callFunc);
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                if (!failcb) {
                    failcb = callFunc;
                }
                Http.Error({ XMLHttpRequest, textStatus, errorThrown, data }, failcb)
            }
        });
    },



    //获取列表表头专用
    GetField: function(url, data, callFunc, failcb) {

        let type = 1; //JSON
        let url_g = "";
        if (url.indexOf(".json") > 0) {
            url_g = "/static/data/jsonfile" + url;
            if (url.indexOf("jsonfile/") >= 0) {
                url_g = url;
            }
        } else {
            url_g = Http.ApiUrl(url);
            type = 2; //API
        }


        let token = this.GetToken(url);
        $.ajax({
            type: "get",
            async: false,
            url: url_g,
            data: data,
            headers: {
                "token": token
            },
            timeout: 59000,
            dataType: "json",
            //jsonp: "callback", //传递给请求处理程序或页面的，用以获得jsonp回调函数名的参数名(一般默认为:callback)
            //jsonpCallback:"?",//自定义的jsonp回调函数名称，默认为jQuery自动生成的随机函数名，也可以写"?"，jQuery会自动为你处理数据
            success: function(res) {
                if (type == 1) {
                    res = { code: 0, data: res };
                }
                Http.SuccessResult(res, callFunc);
            },
            error: function(XMLHttpRequest, textStatus, errorThrown, data) {
                if (!failcb) {
                    failcb = callFunc;
                }
                Http.Error({ XMLHttpRequest, textStatus, errorThrown, data }, failcb)
            }
        });
    },


    //Promise方式的 Post通用方法
    PostPromise: function(url, data) {
        var promise = new Promise(function(successcb, failcb) {
            Http.Post(url, data, successcb, failcb)
        });
        return promise;
    },


    //Promise方式的 Get通用方法
    GetPromise: function(url, data) {
        var promise = new Promise(function(successcb, failcb) {
            Http.Get(url, data, successcb, failcb)
        });
        return promise;
    },


    //导出
    ExcelExport: function(url, data) {
        return this.PostPromise(url, JSON.stringify(data)).then(result => {
            return result
        }).then(key => {
            if (key.code != 0) {
                return key.message;
            } else {
                let signatureUrl = key.data.signatureUrl
                location.href = signatureUrl
            }
        })
    },
    ExcelExport2: function(url, data) {
        return this.PostPromise(url, JSON.stringify({ paramMap: data })).then(result => {
            return result
        }).then(key => {
            if (key.code != 0) {
                return key.message;
            } else {
                let signatureUrl = key.data.signatureUrl
                location.href = signatureUrl
            }
        })
    },
    CheckLogin: function(type) {


        top.location.href = "/main/login.html";
        return;





    },
    // 判断是否是智能薪酬微服务的接口
    isSalarySys(url) {
        let marignurl = url;
        if (url.indexOf('/') != 0) {
            marignurl = '/' + url
        } 
        if(marignurl.indexOf('/payrollbase/')==0||marignurl.indexOf('/excel/')==0||marignurl.indexOf('/payslip/')==0||marignurl.indexOf('/auth/')==0||marignurl.indexOf('/message/')==0||marignurl.indexOf('/global/')==0||marignurl.indexOf('/tools/')==0||marignurl.indexOf('/organize/')==0||marignurl.indexOf('/personnel/')==0||marignurl.indexOf('/soin/')==0||marignurl.indexOf('/saastosimple/')==0||marignurl.indexOf('/statistics/')==0){
            return true;
        }
        return false;
    },
    // 如果是智能薪酬微服务不用拼接ehr_saas
    backBaseApi(url){
        if(Http.isSalarySys(url)){
            return  API.apiBase.substring(0,API.apiBase.length - 9)
        }
        return  API.apiBase
    },
}

export default Http;